import _Close from "@mui/icons-material/Close";
import React from 'react';
import { ButtonContainer, withDropShadow } from 'app/components/tv/customControls/SharedCustomControlsStyles';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1t0zw9b-0"
})(["font-size:", ";padding-left:calc(", " + env(safe-area-inset-left));"], SIZES['24'], SIZES['24']);
const StyledClose = withDropShadow(_Close);
export const ExitPlayerButton = _ref => {
  let {
    onExitPlayer
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "ExitPlayerButton",
    "data-sentry-source-file": "ExitPlayerButton.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: onExitPlayer,
    noMargin: true,
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "ExitPlayerButton.tsx"
  }, /*#__PURE__*/React.createElement(StyledClose, {
    "data-sentry-element": "StyledClose",
    "data-sentry-source-file": "ExitPlayerButton.tsx"
  })));
};